import { render, staticRenderFns } from "./DisruptionIcon.vue?vue&type=template&id=38393992"
import script from "./DisruptionIcon.vue?vue&type=script&lang=js"
export * from "./DisruptionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports